module.exports = __webpack_public_path__ + "static/contact-af887d1f3be07d774e619bc0b7f5e479.png";